module.exports = __webpack_public_path__ + "img/hmapp.53172146.png";